"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sectionAsCSV = exports.asCSV = void 0;
const tslib_1 = require("tslib");
function asCSV(rawReport) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const csvFiles = [];
        for (const section of rawReport.sections) {
            const csv = sectionAsCSV(section);
            csvFiles.push(csv);
        }
        return csvFiles;
    });
}
exports.asCSV = asCSV;
function sectionAsCSV(section) {
    const csvData = [];
    csvData.push(section.subtitles.join(','));
    for (const entry of section.data) {
        const csvEntry = [];
        for (const subtitle of section.subtitles) {
            csvEntry.push(JSON.stringify(entry[subtitle]));
        }
        csvData.push(csvEntry.join(','));
    }
    return csvData.join('\r\n');
}
exports.sectionAsCSV = sectionAsCSV;
//# sourceMappingURL=index.js.map